module.exports = __webpack_public_path__ + "img/multilateral-org.ec47874e.gif";